import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectDocumentGenerationBanks,
  selectDocumentGenerationBanksStatus,
  selectDocumentGenerationCurrencies,
  selectDocumentGenerationCurrenciesStatus,
} from '~/store/covenants/selectors.ts';
import { FetchStatus } from '~/store/covenants/types.ts';
import {
  getDocumentGenerationBankOptions,
  getDocumentGenerationCurrencyOptions,
  getDocumentGenerationShortBankOptions,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

export const useDocumentGenerationOptions = () => {
  const banks = useSelector(selectDocumentGenerationBanks);
  const banksStatus = useSelector(selectDocumentGenerationBanksStatus);
  const currencies = useSelector(selectDocumentGenerationCurrencies);
  const currenciesStatus = useSelector(selectDocumentGenerationCurrenciesStatus);

  return {
    bankOptions: useMemo(() => getDocumentGenerationBankOptions(banks), [banks]),
    shortBankOptions: useMemo(() => getDocumentGenerationShortBankOptions(banks), [banks]),
    currencyOptions: useMemo(
      () => getDocumentGenerationCurrencyOptions(currencies),
      [currencies]
    ),
    isBanksLoading: banksStatus === FetchStatus.Loading,
    isCurrenciesLoading: currenciesStatus === FetchStatus.Loading,
  };
};
